export * from './Label.component'
export * from './Label.types'
